import { BeneficiaryAdultMeta } from '/@/modules/estateaccount/models/meta/BeneficiaryAdultMeta';
import { BeneficiaryCategory } from '/@/modules/beneficiary/enums/BeneficiaryCategory';
import { ExecutorAccountMeta } from '/@/modules/estateaccount/models/meta/ExecutorAccountMeta';

export class ExecutorAndBeneficiaryAccountMeta {
  /**
   * @param meta
   * @returns {BaseBeneficiaryMeta}
   */
  static factory(meta = {}) {
    return Object.assign(
      new this(),
      new ExecutorAccountMeta(meta),
      new BeneficiaryAdultMeta({ category: BeneficiaryCategory.ADULT.key, ...meta })
    );
  }
}
